export default "__VITE_ASSET__Co3qs3ny__"